module.exports = __webpack_public_path__ + "img/1F62D.98b4c6dd.svg";